import { jsx as _jsx } from "react/jsx-runtime";
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { updateURLWith } from '../../util/url-query-params';
import { getValidAccessToken } from '../../volunteer-service/rest/create-rest-context';
const renderSignUpForm = (elements) => () => [...elements]
    .map((e) => ({
    root: ReactDOM.createRoot(e),
    volunteerApiUri: e.getAttribute('data-volunteer-api-uri') || '',
    volunteerAppSecret: e.getAttribute('data-volunteer-app-secret') || '',
    labels: JSON.parse(e.getAttribute('data-labels') || '{}'),
    registrationUrl: e.getAttribute('data-registration-url') || '',
    assignmentId: new URLSearchParams(window.location.search).get('sign_up') || '',
    closeDialogHandler: () => { var _a, _b; return (_b = (_a = e.closest('dialog')) === null || _a === void 0 ? void 0 : _a.querySelector('button.c-modal__close')) === null || _b === void 0 ? void 0 : _b.click(); },
}))
    .filter(({ volunteerApiUri, volunteerAppSecret, assignmentId }) => volunteerApiUri.length > 0 && volunteerAppSecret.length > 0 && assignmentId.length > 0)
    .forEach(({ root, volunteerApiUri, volunteerAppSecret, assignmentId, closeDialogHandler, labels, registrationUrl, }) => {
    root.render(_jsx(React.StrictMode, { children: _jsx(App, { assignmentId: assignmentId, volunteerApiUri: volunteerApiUri, volunteerAppSecret: volunteerAppSecret, closeDialog: closeDialogHandler, labels: labels, registrationUrl: registrationUrl }) }));
});
const onCloseDialog = (e) => (event) => {
    event.preventDefault();
    updateURLWith({ remove: ['sign_up'] }, false);
    axios({
        method: 'get',
        url: `${e.getAttribute('data-sign-out-url')}`,
    }).then(() => window.location.reload());
};
const showDialog = () => [...document.querySelectorAll('.js-show-assignment-sign-up-dialog')]
    .map((e) => {
    var _a;
    return ({
        element: e,
        dialogId: `${(_a = e === null || e === void 0 ? void 0 : e.dataset) === null || _a === void 0 ? void 0 : _a.open}`,
    });
})
    .filter(({ dialogId }) => dialogId && dialogId.length > 0)
    .forEach(({ element, dialogId }) => {
    const elements = () => [...document.querySelectorAll(`#${dialogId} .js-assignment-sign-up`)]
        .filter((e) => e.children.length === 0)
        .filter((e) => { var _a; return ((_a = e.getAttribute('data-sign-out-url')) !== null && _a !== void 0 ? _a : '').length > 0; })
        .map((e) => {
        var _a;
        (_a = e.closest('dialog')) === null || _a === void 0 ? void 0 : _a.addEventListener('close', onCloseDialog(e));
        return e;
    });
    element.addEventListener('click', renderSignUpForm(elements()));
    element.click();
    element.remove();
});
document.addEventListener('DOMContentLoaded', () => {
    getValidAccessToken()
        .then(showDialog)
        .catch(() => { }); //TODO: handle not authenticated
});
